// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.wizard.LeaseWizardWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  GetFirstNodeInSectionCategoryResponseDto,
  GetLeaseStatusForNodeResponseDto,
  GetLeaseStatusWebApiResponseDto,
  GetNextNodeResponseDto,
  GetPreviousNodeResponseDto,
  ReevaluateLeaseCompletionRequestDto,
  ReevaluateLeaseCompletionWebApiResponseDto,
  SubmitDataRequestDto,
  SubmitDataResponseDto,
} from '../..';

interface GetFirstNodeInSectionCategoryParams {
  leaseId: number;
  sectionCategory: string;
}
interface GetLeaseStatusParams {
  leaseId: number;
}
interface GetLeaseStatusForNodeParams {
  leaseId: number;
  nodeId: number;
}
interface GetNextNodeParams {
  currentNodeId: number;
  leaseId: number;
}
interface GetPreviousNodeParams {
  currentNodeId: number;
  leaseId: number;
}

export const LeaseWizardWebApiHandler_getFirstNodeInSectionCategory_Path =
  '/api/web/v1/wizard/getFirstNodeInSectionCategory';

/**
 * get the first node given a section category string
 */
export const LeaseWizardWebApiHandler_getFirstNodeInSectionCategory = (
  getParams: GetFirstNodeInSectionCategoryParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetFirstNodeInSectionCategoryParams, never, GetFirstNodeInSectionCategoryResponseDto>(
    {
      getParams: getParams,
      endpoint: LeaseWizardWebApiHandler_getFirstNodeInSectionCategory_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeaseWizardWebApiHandler_getLeaseStatus_Path = '/api/web/v1/wizard/getLeaseStatus';

/**
 * get status of lease creation
 */
export const LeaseWizardWebApiHandler_getLeaseStatus = (getParams: GetLeaseStatusParams, client = getClient()) => {
  return httpFrontEndRequest<GetLeaseStatusParams, never, GetLeaseStatusWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: LeaseWizardWebApiHandler_getLeaseStatus_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeaseWizardWebApiHandler_getLeaseStatusForNode_Path = '/api/web/v1/wizard/getLeaseStatusForNode';

/**
 * get the lease status with regard to a specific node
 */
export const LeaseWizardWebApiHandler_getLeaseStatusForNode = (
  getParams: GetLeaseStatusForNodeParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetLeaseStatusForNodeParams, never, GetLeaseStatusForNodeResponseDto>(
    {
      getParams: getParams,
      endpoint: LeaseWizardWebApiHandler_getLeaseStatusForNode_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeaseWizardWebApiHandler_getNextNode_Path = '/api/web/v1/wizard/getNextNode';

/**
 * get the current status of the next node
 */
export const LeaseWizardWebApiHandler_getNextNode = (getParams: GetNextNodeParams, client = getClient()) => {
  return httpFrontEndRequest<GetNextNodeParams, never, GetNextNodeResponseDto>(
    {
      getParams: getParams,
      endpoint: LeaseWizardWebApiHandler_getNextNode_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeaseWizardWebApiHandler_getPreviousNode_Path = '/api/web/v1/wizard/getPreviousNode';

/**
 * get the current status of the previous node
 */
export const LeaseWizardWebApiHandler_getPreviousNode = (getParams: GetPreviousNodeParams, client = getClient()) => {
  return httpFrontEndRequest<GetPreviousNodeParams, never, GetPreviousNodeResponseDto>(
    {
      getParams: getParams,
      endpoint: LeaseWizardWebApiHandler_getPreviousNode_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeaseWizardWebApiHandler_reevaluateLeaseCompletion_Path = '/api/web/v1/wizard/reevaluateLeaseCompletion';

/**
 * reevaluate lease completion after changes to data for cosmos leases
 */
export const LeaseWizardWebApiHandler_reevaluateLeaseCompletion = (
  postData: ReevaluateLeaseCompletionRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, ReevaluateLeaseCompletionRequestDto, ReevaluateLeaseCompletionWebApiResponseDto>(
    {
      endpoint: LeaseWizardWebApiHandler_reevaluateLeaseCompletion_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};

export const LeaseWizardWebApiHandler_submitData_Path = '/api/web/v1/wizard/submitData';

/**
 * submit data on node
 */
export const LeaseWizardWebApiHandler_submitData = (postData: SubmitDataRequestDto, client = getClient()) => {
  return httpFrontEndRequest<never, SubmitDataRequestDto, SubmitDataResponseDto>(
    {
      endpoint: LeaseWizardWebApiHandler_submitData_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};
